import React, {HTMLProps} from 'react';
import './Table.css';

const Table: React.FC<HTMLProps<HTMLTableElement>> = props => {
  return (
    <table {...props} style={{
      width: '100%',
      ...props.style
    }}>
      {props.children}
    </table>
  );
};
export default Table;